import { FC } from 'react';
import { Select } from '@doda/io-react/pc';
import { INCOME } from '@doda/common/src/constants/screenStructure/searchConditionItems';
import styles from './index.module.scss';

/**
 * Props
 * @param isUpper 文言の表示切替
 * @param defaultValue 初期値
 * @param onChange 更新処理
 */
interface Props {
  isUpper: boolean;
  defaultValue: string;
  onChange: (value: string) => void;
}

const DEFAULT_LABEL = '指定しない';

const incomeOptionList = INCOME.list.map((item) => {
  const label = item.name === '未設定' ? DEFAULT_LABEL : item.name;
  return { label, value: item.id };
});

/**
 * 検索サイトバー・年収
 */
export const SearchIncomeSelect: FC<Props> = ({
  isUpper,
  defaultValue,
  onChange,
}) => {
  const selectedOption = INCOME.list.find(
    (option) => option.id === defaultValue
  );
  const selectedName = selectedOption ? selectedOption.name : DEFAULT_LABEL;

  return (
    <div className={styles.searchIncomeSelect__wrapper}>
      <div className={styles.searchIncomeSelect__form}>
        <Select
          onChange={onChange}
          selectedOption={{
            value: defaultValue,
            label: selectedName === '未設定' ? DEFAULT_LABEL : selectedName,
          }}
          options={incomeOptionList}
          className={styles.searchIncomeSelect__select}
        />
      </div>
      <div className={styles.searchIncomeSelect__text}>
        {isUpper ? '以上' : '以下'}
      </div>
    </div>
  );
};
